import { gql, useQuery } from '@apollo/client';
import { useAuth } from '../auth/useAuth';
import { LEARNING_ACTIVITY_PARAMS, isLocalizedCourseCatalogItemEnabled } from '../../common/constants';
import { useLogger } from '@amzn/xb-hooks';
import { LEARNER_RECORDS_ERROR } from '../../common/rumMetrics';

export const LEARNING_ACTIVITIES_BY_USER_ID = gql`
    query learningActivitiesByUserId($userId: ID! $queryRegistrationCounter: Boolean = true $queryCourseCatalogItemLimited: Boolean = false $queryLocalizedCourseCatalogItem: Boolean = false) {
        registrationsByUserId(userId: $userId, filter: { registrationModalityType: ILT }) {
            nodes {
                registrationStatus
                registrationType
                learningActivity {
                  ${LEARNING_ACTIVITY_PARAMS}
                }
            }
        }
        classroomTrainingAssignmentsByUserId(userId: $userId, filter: {assignmentStatus: ASSIGNED}) {
            nodes {
                trainingAssignmentStatus
                learningActivity {
                  ${LEARNING_ACTIVITY_PARAMS}
                }
            }
        }
        transcriptsByUserId(userId: $userId) {
            nodes {
                id
                learningActivity {
                    pk
                }
                transcriptStatus
            }
        }
        iltEvaluationsByUserId(userId: $userId) {
            nodes {
                evaluationUrl
                evaluationStatus
                learningActivity {
                    pk
                }
            }
        }
    }
`;

export const useLearningActivitiesByUserId = () => {
    const { log, count } = useLogger();
    const { user } = useAuth();
    const variables = {
        userId: user.id,
        queryLocalizedCourseCatalogItem: isLocalizedCourseCatalogItemEnabled(),
    };
    const result = useQuery(LEARNING_ACTIVITIES_BY_USER_ID, {
        skip: !user.id,
        variables,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
        onError: (error) => {
            log.error(
                'Error requesting learner records (registrations, training assignments, transcripts, and evaluations) by userId',
                error,
            );
            count(LEARNER_RECORDS_ERROR);
        },
    });

    return {
        ...result,
        refetch: result.refetch,
    };
};
